<script>
  import { templateDemo } from "../helper/TextGenerator";
  import { Button, Textarea, Select } from "../components/ui";

  let model = `{% layout hero, {headline: 'My Headline'} %} {% layout row, {entries: [{headline: 'My Headline 2'}, {headline: 'My Headline 3'}]} %}`;
  let data = null;
  const types = [
    { Text: "Design 1", Value: 0 },
    { Text: "Design 2", Value: 1 }
  ];
  let type = 0;

  const submit = async function() {
    data = await templateDemo(model, type);
  };

</script>
<div>
  <Select class="mb-2" bind:model={type} list={types} />
  <Textarea bind:model />
  <Button class="mt-4" primary={true} on:submit={submit}>Generate</Button>
  <div class="mt-6">
    <b>Renderd</b>
    <div class="border-2 mt-2 p-4">
      {@html data}
    </div>
  </div>
  <div class="mt-6">
    <b>HTML</b>
    <div class="border-2 mt-2 p-4">{data}</div>
  </div>
</div>
